const FooterStyles = {
  footerContainer: {
    height: "52px",
    borderTop: " 1px solid #D8D8D8",
    padding: "0px 15px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "@media(max-width: 780px)": {
      height: "104px",
      flexDirection: "column",
      justifyContent: "center",
      gap: "15px",
    },
  },
  copyRights: {
    fontFamily: "Noto Sans",
    fontSize: "16px",
    fontWeight: "400",
    textAlign: " left",
    opacity: "75%",
  },
  footerItems: {
    width: "30%",
    display: "flex",
    alignItems: "center",
    marginRight: 10,
    justifyContent: "space-between",
    "@media(max-width: 780px)": {
      width: "100%",
      marginRight: 0,
    },
    "@media(min-width: 768px) and (max-width:1200px)": {
      width: "100%",
      paddingX: 10,
    },
  },
  rightText: {
    fontFamily: "Noto Sans",
    fontSize: "16px",
    fontWeight: "400",
  },
};

export default FooterStyles;
